var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfNextSkip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2583 11.8547C12.1168 11.8547 11.9995 11.8074 11.9064 11.7127C11.8132 11.6181 11.7666 11.5005 11.7666 11.3599V4.62273C11.7666 4.49324 11.8143 4.38117 11.9095 4.28652C12.0048 4.19186 12.1231 4.14453 12.2646 4.14453C12.395 4.14453 12.5068 4.19186 12.5999 4.28652C12.6931 4.38117 12.7397 4.49324 12.7397 4.62273V11.3599C12.7397 11.5005 12.6921 11.6181 12.5968 11.7127C12.5015 11.8074 12.3887 11.8547 12.2583 11.8547ZM5.18462 11.2137C4.97778 11.3539 4.772 11.3719 4.5673 11.2679C4.3626 11.1638 4.26025 10.9945 4.26025 10.7599V5.2394C4.26025 4.99901 4.3626 4.82823 4.5673 4.72706C4.772 4.62589 4.97778 4.63983 5.18462 4.7689L9.18457 7.51245C9.34953 7.63638 9.432 7.7992 9.432 8.00091C9.432 8.20263 9.34953 8.36459 9.18457 8.48681L5.18462 11.2137Z",
    fill: "#374151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfNextSkip);
export default __webpack_public_path__ + "static/media/pdf-next-skip.7dac50998f8084a0770f0ae3c007ed0c.svg";
export { ForwardRef as ReactComponent };